// IMobileSystem.js
// Enterprise-grade interface definitions for mobile systems
// Ensures consistent implementation across all mobile components

/**
 * Interface for mobile detection services
 */
export class IMobileDetectionService {
    /**
     * Detect if current device is mobile
     * @returns {boolean}
     */
    static isMobile() {
        throw new Error('IMobileDetectionService.isMobile() must be implemented');
    }
    
    /**
     * Get comprehensive device information
     * @returns {Object}
     */
    static getDeviceInfo() {
        throw new Error('IMobileDetectionService.getDeviceInfo() must be implemented');
    }
}

/**
 * Interface for mobile input handlers
 */
export class IMobileInputHandler {
    /**
     * Initialize the input handler
     */
    initialize() {
        throw new Error('IMobileInputHandler.initialize() must be implemented');
    }
    
    /**
     * Register gesture callback
     * @param {string} gestureType
     * @param {Function} callback
     */
    on(gestureType, callback) {
        throw new Error('IMobileInputHandler.on() must be implemented');
    }
    
    /**
     * Get handler status
     * @returns {Object}
     */
    getStatus() {
        throw new Error('IMobileInputHandler.getStatus() must be implemented');
    }
}

/**
 * Interface for mobile UI components
 */
export class IMobileUIComponent {
    /**
     * Create the component
     */
    create() {
        throw new Error('IMobileUIComponent.create() must be implemented');
    }
    
    /**
     * Show the component
     */
    show() {
        throw new Error('IMobileUIComponent.show() must be implemented');
    }
    
    /**
     * Hide the component
     */
    hide() {
        throw new Error('IMobileUIComponent.hide() must be implemented');
    }
    
    /**
     * Destroy the component
     */
    destroy() {
        throw new Error('IMobileUIComponent.destroy() must be implemented');
    }
}

/**
 * Interface for error boundaries
 */
export class IErrorBoundary {
    /**
     * Wrap a function with error handling
     * @param {Function} fn
     * @param {*} fallback
     * @returns {*}
     */
    static wrap(fn, fallback) {
        throw new Error('IErrorBoundary.wrap() must be implemented');
    }
    
    /**
     * Wrap an async function with error handling
     * @param {Function} fn
     * @param {*} fallback
     * @returns {Promise<*>}
     */
    static async wrapAsync(fn, fallback) {
        throw new Error('IErrorBoundary.wrapAsync() must be implemented');
    }
}
